/* External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { validateAuthFields } from '../../redux/validateAuthFields';
import { ForgotPasswordAction, ForgotPasswordActionTypes } from './actions';

export interface ForgotPasswordState {
  loading: boolean;
  error?: any;
  forgotPasswordEmail?: string;
  forgotPasswordCodeSent?: boolean;
  forgotPasswordSuccess?: boolean;
  codeVerified?: boolean;
  forgotPasswordFields: {
    email?: string;
    verificationCode?: string;
    newPassword?: string;
    confirmPassword?: string;
  };
}

export const initialForgotPasswordState: ForgotPasswordState = {
  loading: false,
  forgotPasswordFields: {
    email: '',
    verificationCode: '',
    newPassword: '',
    confirmPassword: '',
  },
};

export default function forgotPasswordReducer(
  state = initialForgotPasswordState,
  action: ForgotPasswordAction,
): ForgotPasswordState {
  switch (action.type) {
    case ForgotPasswordActionTypes.FORGOT_PASSWORD_REQUEST: {
      return update(state, {
        loading: { $set: true },
      });
    }

    case ForgotPasswordActionTypes.FORGOT_PASSWORD_SUCCESS:
      return update(state, {
        loading: { $set: false },
        forgotPasswordCodeSent: { $set: true },
        forgotPasswordEmail: { $set: action.username },
      });

    case ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
        forgotPasswordCodeSent: { $set: false },
      });

    case ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_REQUEST: {
      return update(state, {
        loading: { $set: true },
      });
    }

    case ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_SUCCESS:
      return update(state, {
        loading: { $set: false },
        forgotPasswordSuccess: { $set: true },
        forgotPasswordCodeSent: { $set: false },
      });

    case ForgotPasswordActionTypes.CONFIRM_FORGOT_PASSWORD_ERROR:
      return update(state, {
        error: { $set: action.error },
        loading: { $set: false },
        forgotPasswordSuccess: { $set: false },
      });

    case ForgotPasswordActionTypes.SET_FORGOT_PASSWORD_FIELD: {
      const newState = validateAuthFields(state, { [action.field]: action.value }, 'forgotPasswordFields');

      if (action.field === 'verificationCode') {
        return update(newState, {
          codeVerified: { $set: false },
        });
      }

      return newState;
    }

    case ForgotPasswordActionTypes.VERIFY_CODE_REQUEST: {
      return update(state, { codeVerified: { $set: true } });
    }

    default:
      return state;
  }
}
